import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { actions as commonActions } from "../../modules/commonModule"
import { selectors as userSelectors } from "../../modules/userModule"
import { formatDate } from "../../modules/utilities"
import { CONSTANTS, KEY_VALUES } from "../../modules/constants"

import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import Button from "@mui/material/Button"
import { withStyles } from "@mui/styles"

const styles = theme => ({
  text: {
    whiteSpace: "pre-wrap"
  }
})

const trialTitleMessage = "WELCOME TO YOUR NUMERABLE TRIAL!"

const trialEndTitleMessage = "YOUR NUMERABLE TRIAL ENDS TODAY!"

const registeredMessage = "You can now explore Numerable's detailed data on FTSE 100 companies, their boards and directors."

const trialDurationMessage = "Your free trial of Numerable runs until "

const trialMessage = [
  /* 0 */ "This is your last chance to try Numerable for free.",

  /* 1 */ "Your trial of a subscription to Numerable is running out - have you explored all the features yet?",

  /* 2 */ "LSE Advisers data lets you see the main board advisers for each FTSE company, and list clients for each adviser.",

  /* 3 */ "External links take you directly to more information on the company or person you are viewing: e.g. accounts, Companies House, LinkedIn.",

  /* 4 */ "Export as CSV (not available in the trial) outputs a file in comma-separated-variables format, to load into a spreadsheet like Excel.",

  /* 5 */ "The Snapshot PDF feature generates an A4 snapshot to print or save as a summary of the company or person you are viewing.",

  /* 6 */ "Select the Connections radio button on a Company or Person page to list the connected companies for a company (those that share a director) or the co-directors of a person.",

  /* 7 */ "The Alerts feature lets you configure email alerts for regulatory news releases that match your settings.",

  /* 8 */ "When viewing a table, sort the rows by clicking on a column header.",

  /* 9 */ "On the COMPANY and PERSON pages you can click on the Past checkbox to view past directors and roles.",

  /* 10 */ "On the COMPANY and PERSON pages, the 3 View icons show different ways to visualise the information - try the Timeline view to see when each role starts and ends.",

  /* 11 */ "The COMPANY and PERSON pages let you view the directors of a company or board roles of a person, and then click through for more details.",

  /* 12 */ "LSE boards and roles are updated daily - news releases appear within 30 minutes of publication!",

  /* 13 */"Subscribed users have full access to details of UK listed companies in the FTSE 250, FTSE SmallCaps, AIM",
]

const websiteMessage = `There is more information about Numerable's subscriptions at <a href="https:numerable.io" target="_blank" rel="noopener noreferrer" >www.numerable.io</a>`

const contactMessage = [
  "To take out a subscription or discuss Numerable please ",
  "- email "
]

const phoneText = " or phone "
const phoneLink = <a href="tel:07866687154">0786 668 7154</a>

const emailLink = <a href="mailto:info@numerable.io?subject=Numerable" target="_blank" rel="noopener noreferrer" >info@numerable.io</a>
const contactLink = <a href="https://www.numerable.io/contact/" target="_blank" rel="noopener noreferrer" >contact us</a>

const useCasesLink = "https://www.numerable.io/home/saas/use-cases/?utm_medium=numapp&utm_campaign=trial"

class StandardTrialModal extends Component {

  render() {
    // console.log("this.props: ", this.props)

    const { loading, standardTrialDaysLeft } = this.props

    // console.log("standardTrialDaysLeft: " + standardTrialDaysLeft)

    const dontShowAgain = () => {
      this.props.common.setStandardTrialModalShown(true)
      return null
    }

    // find last day of trial
    const today = new Date()
    const lastDate = new Date(today.getTime() + (1000 * 60 * 60 * 24 * (standardTrialDaysLeft - 1)))
    const lastDateString = formatDate(lastDate, true)

    return (
      <React.Fragment>

        <Dialog
          disableRestoreFocus={true}
          open={true} // {Boolean(open)}
          // onClose={onClose}
          maxWidth="sm" fullWidth>

        {standardTrialDaysLeft > 1 &&<DialogTitle>{trialTitleMessage}</DialogTitle>}
        {standardTrialDaysLeft <= 1 &&<DialogTitle>{trialEndTitleMessage}</DialogTitle>}

          <DialogContent>
            {/* first day */}
            {standardTrialDaysLeft === CONSTANTS.STANDARD_TRIAL_LENGTH &&
              <React.Fragment>
                <DialogContentText>Thank you for registering for Numerable.</DialogContentText>
                <DialogContentText>{trialDurationMessage}{lastDateString}.</DialogContentText>
                <DialogContentText>{registeredMessage}</DialogContentText>
                <DialogContentText>{trialMessage[CONSTANTS.STANDARD_TRIAL_LENGTH - 1]}.</DialogContentText>
                <DialogContentText>{contactMessage[0]}{contactLink}</DialogContentText>
              </React.Fragment>
            }

            {/* in 14 day trial */}
            {standardTrialDaysLeft > 1 && standardTrialDaysLeft < CONSTANTS.STANDARD_TRIAL_LENGTH &&
              <React.Fragment>
                <DialogContentText>{trialDurationMessage}{lastDateString}.</DialogContentText>
                <DialogContentText>You have {standardTrialDaysLeft} days left, including today.</DialogContentText>
                <DialogContentText>TIP: {trialMessage[standardTrialDaysLeft - 1]}</DialogContentText>
                <DialogContentText>{contactMessage[0]}{contactLink}</DialogContentText>
              </React.Fragment>
            }

            {/* last day */}
            {standardTrialDaysLeft === 1 &&
              <React.Fragment>
                <DialogContentText>{trialMessage[0]}</DialogContentText>
                <DialogContentText>{contactMessage[0]}</DialogContentText>
                <DialogContentText>{contactMessage[1]}{emailLink}{phoneText}{phoneLink}</DialogContentText>
              </React.Fragment>
            }

            {/* standardTrialDaysLeft undefined - should never happen as trapped in home and nexus pages */}
            {standardTrialDaysLeft === undefined &&
              <React.Fragment>
              </React.Fragment>
            }
          </DialogContent>

          <DialogActions>
            {/* update with link to subscription features on website when available
              <Button target="_blank" href={useCasesLink} color="primary">View use cases</Button>
            */}

            <Button variant="contained" disabled={loading} onClick={dontShowAgain} color="primary">Continue</Button>

          </DialogActions>

        </Dialog>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ common, user }) => {
  return {
    standardTrialDaysLeft: userSelectors.getTrialDaysRemaining(user),
    standardTrialModalShown: common.standardTrialModalShown,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    common: bindActionCreators(commonActions, dispatch),
  }
}

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StandardTrialModal))

